import React, { Component } from "react";
import zirconLogo from "../../assets/images/zircon.jpeg";
import { withRouter } from "react-router-dom";

class LayoutHeader extends Component {
  render() {
    return (
      <div className="main-header" style={{ background: "rgb(102,51,153)" }}>
        {/* <div className="zirconLogo">
          <img src={zirconLogo} alt="zircon-logo" height={60} />
        </div> */}
        <div style={{ margin: "auto" }}></div>
        <div className="header-part-right">
          <div
            className="user col align-self-end"
            style={{ fontSize: 18, color: "white", fontWeight: 900 }}
          >
            <span>Hedera Hackaton 2021</span>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(LayoutHeader);
